import React from 'react';
import { ArrowDown, ArrowUp, ChevronsUpDown, EyeOff } from 'lucide-react';
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger, } from '@cargomatic/ui';
export function ColumnHeader({ title, sorted, onSort, onHide, className = '', }) {
    if (!onSort && !onHide) {
        return React.createElement("div", { className: className }, title);
    }
    return (React.createElement("div", { className: `flex items-center space-x-2 ${className}` },
        React.createElement(DropdownMenu, null,
            React.createElement(DropdownMenuTrigger, { asChild: true },
                React.createElement(Button, { variant: "ghost", size: "sm", className: "-ml-3 h-8 data-[state=open]:bg-accent" },
                    React.createElement("span", null, title),
                    sorted === 'desc' ? (React.createElement(ArrowDown, { className: "ml-2 h-4 w-4" })) : sorted === 'asc' ? (React.createElement(ArrowUp, { className: "ml-2 h-4 w-4" })) : (React.createElement(ChevronsUpDown, { className: "ml-2 h-4 w-4" })))),
            React.createElement(DropdownMenuContent, { align: "start" },
                onSort && (React.createElement(React.Fragment, null,
                    React.createElement(DropdownMenuItem, { onClick: () => onSort('asc') },
                        React.createElement(ArrowUp, { className: "mr-2 h-3.5 w-3.5 text-muted-foreground/70" }),
                        "Asc"),
                    React.createElement(DropdownMenuItem, { onClick: () => onSort('desc') },
                        React.createElement(ArrowDown, { className: "mr-2 h-3.5 w-3.5 text-muted-foreground/70" }),
                        "Desc"))),
                onHide && (React.createElement(React.Fragment, null,
                    onSort && React.createElement(DropdownMenuSeparator, null),
                    React.createElement(DropdownMenuItem, { onClick: onHide },
                        React.createElement(EyeOff, { className: "mr-2 h-3.5 w-3.5 text-muted-foreground/70" }),
                        "Hide")))))));
}
